module.exports = __webpack_public_path__ + "img/logo_ucity.b1c91b41.png";